import React from 'react'
import classNames from 'classnames'
import './option.scss'
import { Option as OptionType } from '../combobox'
import { LucideIcon } from '../../../utils/lucideIcon'

interface OptionProps {
    option: OptionType
    props: any
    selected: boolean
}

export const Option = ({ props, option, selected }: OptionProps) => {
    if (!option) return null

    return (
        <li {...props} className={classNames('combobox-option', { selected })}>
            <LucideIcon
                className="combobox-option-icon"
                iconName={option.iconName}
                title={option.iconTitle}
                size={16}
            />
            <div className="combobox-option-content" title={option.title}>
                {option.eyebrow && <div className="combobox-option-eyebrow">{option.eyebrow}</div>}
                <div className="combobox-option-label">
                    <span className="combobox-option-label-text">{option.renderLabel ?? option.label}</span>
                    {option.secondaryLabel && (
                        <span className="combobox-option-secondary-label">{option.secondaryLabel}</span>
                    )}
                </div>
            </div>
        </li>
    )
}
